module.exports = __webpack_public_path__ + "static/images/pulse.7f6280324d2b53788d7df5774b23b230.svg";